export const defaultBoxStyles = {
  padding: "1rem 0",
};

export const dateFieldStyles = {
  width: "295px",
  background: "white",
};

export const hourFieldStyles = {
  width: "225px",
  background: "white",
};

export const hourDividerStyles = {
  fontSize: "3rem",
  lineHeight: 1,
};
